import React from 'react';

import Base from './Base.jsx';

import AssetsLinks from '../Components/AssetsLinks/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-assets-links';
  }

  renderElement(element) {
    var links = element.dataset.links;
    if (links) {
      links = JSON.parse(links);
    }


    return (
      <AssetsLinks links={links} />
    );
  }
}


export default EntryPoint;

